import { html, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';

import { getGlobalStyleSheets } from '../../global-styles';

import { ActionBarTags } from './action-bar.types.ts';

import ActionBarStyles from './action-bar.scss?inline';

@customElement(ActionBarTags.ActionBar)
export class AtlActionBar extends LitElement {
   static styles = [...getGlobalStyleSheets(), ActionBarStyles];

   render() {
      return html`
         <div class="action-bar-container">
            <slot></slot>
         </div>
      `;
   }
}
